/* eslint-disable */ 
import '../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/AppearanceGraph.style.css'
import LineChartComponent from './LineChartGraph.components';
import { useState } from 'react';
import ArrowDown from '../../../../../assets/Icons/Sidebar/ArrowDown.svg'
import SelectFilter from '../../../UniversalComponents/SelectFilter.component';

const AppearanceGraph = ({ graphData }) => {
    const [selectedOption, setSelectedOption] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const handleChange = (event) =>
        setSelectedOption(event.target.value);
    return (
        <div className='appearanceGraphComponent'>
            <div className="graphHeader">
                <h3>Appearance</h3>
                <div className='graphName1'>
                    <div className='denotingCircle'></div>
                    <div>Members</div>
                </div>
                <div className='graphName2'>
                    <div className='denotingCircle'></div>
                    <div>Staffs</div>
                </div>
                <SelectFilter/>
            </div>
            <div className='graphContent'>
                <LineChartComponent data={graphData} />
            </div>
        </div>
    )
}


export default AppearanceGraph